import Footer from '@/components/footer'
import RE from '@/assets/replace.js'
import { TGA } from '@/utils/tga'
import { getSteamStoreUrl } from '@/utils/gg'
import videojs, { players } from 'video.js';
import 'video.js/dist/video-js.css';

const LANG_OPTIONS = [
    { key: 'zh', label: '简体中文' },
    { key: 'zh-TW', label: '繁體中文' },
    { key: 'en', label: 'English' },
    { key: 'ja', label: '日本語' },
    { key: 'ko', label: '한국어' },
    // { key: 'fr', label: 'Français' },
    // { key: 'de', label: 'Deutsch' },
    // { key: 'es', label: 'Español' },
    // { key: 'pt', label: 'Português' },
    // { key: 'ru', label: 'Русский' },
    // { key: 'ar', label: 'العربية' },
    // { key: 'th', label: 'ไทย' },
    // { key: 'vi', label: 'Tiếng Việt' },
    // { key: 'id', label: 'Bahasa Indonesia' },
    // { key: 'tr', label: 'Türkçe' },
    // { key: 'it', label: 'Italiano' },
];

export default {
    components: {
        Footer,
    },
    data() {
        return {
            RE,
            LANG_OPTIONS,
            isShowSelect: false,
            isPublic: false,
            showGuide: false,
            showFun: false,
            wikiEnabled: false,
            lang: 'en',
            showLangPicker: false,
            //轮播 - 使用 require 让 webpack 处理路径
            images: [
                require('../../static/pc/1.png'),
                require('../../static/pc/2.png'),
                require('../../static/pc/3.png'),
                require('../../static/pc/4.png'),
                require('../../static/pc/5.png'),
                require('../../static/pc/6.png')
            ],
            imagesMo: [
                require('../../static/mo/1.png'),
                require('../../static/mo/2.png'),
                require('../../static/mo/3.png'),
                require('../../static/mo/4.png'),
                require('../../static/mo/5.png'),
                require('../../static/mo/6.png')
            ],
            swiperInitialized: true,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                lazy: false, // 关闭 Swiper 的懒加载
                loop: true, // Enable looping
                effect: 'slide', // Slide effect
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "1",
                // spaceBetween: 10, // 幻灯片之间的间距（可选）
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 200,
                    modifier: 1,
                    slideShadows: false,
                },
            },
            swiperOptionMo: {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                lazy: false, // 关闭 Swiper 的懒加载
                loop: true, // Enable looping
                effect: 'slide', // Slide effect
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "1",
                // spaceBetween: 10, // 幻灯片之间的间距（可选）
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 200,
                    modifier: 1,
                    slideShadows: false,
                },
            },
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '568:1010', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: 'video/mp4', // 类型
                        src: 'https://danke.habby.cn/vide.mp4' // url地址
                    }
                ],
                poster: '', // 封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, // 当前时间和持续时间的分隔符
                    durationDisplay: true, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true // 是否显示全屏按钮
                }
            },
            isPlay: false,
            player: null,
            isWx: false,
            isTip: false,
            isShowVideo: false,
            currentVideoSrc: '',
            showToast: false
        }
    },
    computed: {},
    watch: {
        isShowSelect(newValue) {
            if (newValue) {
                this.countdownInterval = setTimeout(() => {
                    this.isShowSelect = false;
                }, 5000);
            } else {
                clearInterval(this.countdownInterval);
            }
        },
    },
    mounted() {
        this.detectLanguage();
        this.fetchWikiConfig();
        TGA.trackShow();

        // 微信浏览器的特殊事件，确保在微信环境下可以手动触发视频播放
        document.addEventListener('WeixinJSBridgeReady', () => {
            this.isWx = true;
        }, false);

        // this.player = videojs(this.$refs.videoPlayer, {
        //     controls: true,
        //     autoplay: false,
        //     preload: 'auto'
        // });
    },
    beforeDestroy() {
        // if (this.player) {
        //     this.player.dispose();
        // }
    },
    methods: {
        detectLanguage() {
            const browserLang = (navigator.language || navigator.userLanguage || 'en').toLowerCase();
            const langMap = {
                'zh-cn': 'zh', 'zh-sg': 'zh', 'zh-tw': 'zh-TW', 'zh-hk': 'zh-TW', 'zh': 'zh',
                'ja': 'ja', 'ko': 'ko', 'fr': 'fr', 'de': 'de', 'es': 'es',
                'pt': 'pt', 'ru': 'ru', 'ar': 'ar', 'th': 'th', 'vi': 'vi',
                'id': 'id', 'tr': 'tr', 'it': 'it', 'en': 'en',
            };
            this.lang = langMap[browserLang] || langMap[browserLang.split('-')[0]] || 'en';
        },
        switchLang(langKey) {
            this.lang = langKey;
            this.showLangPicker = false;
        },
        currentLangLabel() {
            const opt = LANG_OPTIONS.find(l => l.key === this.lang);
            return opt ? opt.label : this.lang;
        },
        async fetchWikiConfig() {
            try {
                const res = await fetch('/api/wiki-config');
                const text = await res.text();
                const data = JSON.parse(text);
                this.wikiEnabled = !!data.wiki;
            } catch (e) {
                this.wikiEnabled = false;
            }
        },
        onClickCard() {
            TGA.trackClick('Wiki');
            this.showFun = false;
            this.showGuide = true;
            this.scrollToTop();
        },
        onClickFun() {
            TGA.trackClick('Fun');
            this.showGuide = false;
            this.showFun = true;
            this.scrollToTop();
        },
        onClickSteam() {
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 2000);
        },
        onClickComponent() {
            TGA.trackClick('Discord');
            window.open('https://discord.gg/j63q9fwNMJ', '_target');
        },
        onClickSteam() {
            TGA.trackClick('Steam');
            window.open(getSteamStoreUrl(), '_target');
        },
        onClickPlay(){
            if(this.isPlay){
                this.isPlay = false;
                this.pauseVideo();
            } else {
                this.isPlay = true;
                this.playVideo();
            }
        },
        playVideo() {
            if (this.player) {
                this.player.play();
            }
        },
        pauseVideo() {
            if (this.player) {
                this.player.pause();
            }
        },
        scrollToTop() {
            const moRootElement = this.$refs.mo_root;
            if (moRootElement) {
                moRootElement.scrollTo({
                    top: 0,
                    behavior: 'smooth' // Smooth scrolling
                });
            } else {
                console.error('mo_root element not found');
            }
        },
        scrollToSwiper() {
            if (this.showGuide || this.showFun) {
                this.showGuide = false;
                this.showFun = false;
                this.$nextTick(() => {
                    this.scrollToSwiper();
                });
                return;
            }
            const moRootElement = this.$refs.mo_root;
            const swiperSection = this.$refs.swiperSection || this.$refs.swiperContainer;
            if (moRootElement && swiperSection) {
                const rootRect = moRootElement.getBoundingClientRect();
                const targetRect = swiperSection.getBoundingClientRect();
                const top = moRootElement.scrollTop + (targetRect.top - rootRect.top);
                moRootElement.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            } else {
                console.error('mo_root or swiper section element not found');
            }
        },
        onClickDiscord() {
            TGA.trackClick('Discord');
            window.open('https://discord.com/invite/FzMHcNpaKH', '_target');
        },
        swiperPrev() {
            const inst = this.$refs.mySwiper && (this.$refs.mySwiper.$swiper || this.$refs.mySwiper.swiperInstance);
            if (inst) {
                inst.slidePrev();
            } else {
                console.error('Swiper instance not found:', this.$refs);
            }
        },
        swiperNext() {
            const inst = this.$refs.mySwiper && (this.$refs.mySwiper.$swiper || this.$refs.mySwiper.swiperInstance);
            if (inst) {
                inst.slideNext();
            } else {
                console.error('Swiper instance not found:', this.$refs);
            }
        },
        //禁止页面滑动
        stop() {
            var mo = function (e) {
                passive: false
            }
            document.body.style.overflow = 'hidden'
            document.addEventListener('touchmove', mo, false) //禁止页面滑动
        },
        //取消滚动限制
        move() {
            var mo = function (e) {
                passive: false
            }
            document.body.style.overflow = '' //出现滚动条
            document.removeEventListener('touchmove', mo, false)
        },
        onClickMoadl(){
            // 使用 require 让 webpack 处理路径
            this.currentVideoSrc = require('../../static/video/steam1.mp4');
            this.isShowVideo = true;
        },
        handleCloseVideo() {
            this.isShowVideo = false;
            this.currentVideoSrc = ''; 
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/index.js